/* Wicket – moteur de recherche du site (panneau de l'en-tête et page de résultats).
   L'index des articles est produit par templates/collection.wk-index.liquid (/collections/all?view=wk-index&page=N),
   chargé une fois puis gardé dans le navigateur ; la recherche se fait ici, sans la recherche « sémantique » de Shopify.
   Références (SKU) : entière, début, fin ou milieu ; mots : nom, type, étiquettes, collection, première ligne de la description.
   Classement : la référence exacte, le mot dans le nom, la collection en cours avant les archives, les articles en stock,
   les costumes, vestes et manteaux avant les gilets seuls. Un mot inconnu ne donne rien. */
(function(root){
  'use strict';
  if(root.WkSearchEngine&&root.WkSearchEngine.search) return;
  var VER='1', TTL=20*60*1000, PER=250;
  var STOP={}; 'le la les l un une des de du d et a au aux en pour avec sans sur par ou the of and with in for to'.split(' ').forEach(function(w){STOP[w]=1;});
  var TYPEB={costume:10,suit:10,veste:9,jacket:9,manteau:9,coat:9,pantalon:6,trousers:6,chemise:6,shirt:6,richelieu:6,'oxford shoes':6,mocassin:6,loafers:6,bottine:6,boots:6,pull:4,jumper:4,cravate:4,tie:4,'bow tie':4,gilet:2,waistcoat:2,pochette:3,'pocket square':3};
  var COLW={dete:'ete',dhiver:'hiver'};
  function norm(s){return String(s==null?'':s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/œ/g,'oe').replace(/æ/g,'ae').replace(/[’'`´–—\-_,;:!?()\[\]\/]/g,' ').replace(/\s+/g,' ').trim();}
  function toks(s){return norm(s).split(/[^a-z0-9]+/).filter(function(t){return t.length>1;});}
  function addAll(o,arr){for(var i=0;i<arr.length;i++)o[arr[i]]=1;}
  function prepare(rows){
    var items=[];
    for(var i=0;i<rows.length;i++){
      var r=rows[i]; if(!r||!r[0]) continue;
      var it={h:r[0],t:r[1]||'',ty:r[2]||'',sk:String(r[3]||'').split('|').filter(Boolean),tags:String(r[4]||'').split('|').filter(Boolean),s:+r[5]||0,a:+r[6]?1:0,p:+r[7]||0,c:+r[8]||0,img:r[9]||'',cols:r[10]||'',d:r[11]||'',i:i};
      it.n=norm(it.t);
      it.tt={};addAll(it.tt,toks(it.t));
      it.tyw={};addAll(it.tyw,toks(it.ty));
      it.tg={};addAll(it.tg,toks(it.tags.join(' ')));
      var cw=[];String(it.cols).split(' ').forEach(function(h){h.split('-').forEach(function(w){if(w)cw.push(COLW[w]||w);});});
      if(it.s===0)cw.push('archives','archive');
      it.cw={};addAll(it.cw,cw.filter(function(t){return t.length>1;}));
      it.dw={};addAll(it.dw,toks(it.d));
      it.skl=it.sk.map(function(k){return String(k).toLowerCase().replace(/\s+/g,' ').trim();});
      it.skc=it.skl.map(function(k){return k.replace(/[^a-z0-9]/g,'');});
      var tyn=norm(it.ty); it.tyb=TYPEB[tyn]; if(it.tyb==null)it.tyb=5;
      it.gilet=/^(gilet|waistcoat)/.test(tyn)||/^(le gilet|the waistcoat|gilet)\b/.test(it.n);
      items.push(it);
    }
    return items;
  }
  /* distance de Damerau-Levenshtein ≤ 1 (une lettre en trop, en moins, changée ou deux lettres inversées) */
  function dl1(a,b){
    var la=a.length,lb=b.length;if(Math.abs(la-lb)>1)return false;
    if(la===lb){var d=[];for(var i=0;i<la;i++)if(a[i]!==b[i]){d.push(i);if(d.length>2)return false;}
      if(d.length<=1)return true;return d[1]===d[0]+1&&a[d[0]]===b[d[1]]&&a[d[1]]===b[d[0]];}
    var s=la<lb?a:b,l=la<lb?b:a,x=0,y=0,skip=false;
    while(x<s.length&&y<l.length){if(s[x]===l[y]){x++;y++;}else{if(skip)return false;skip=true;y++;}}
    return true;
  }
  /* 3 = mot entier, 2 = début de mot (ou mot plus long que le jeton), 1 = à une lettre près, 0 = rien */
  function hit(set,w,fuzzy){
    if(set[w])return 3;
    var best=0;
    for(var t in set){
      if(t.indexOf(w)===0){best=2;break;}
      if(w.length>t.length&&t.length>=4&&w.length-t.length<=2&&w.indexOf(t)===0){best=2;break;}
      if(fuzzy&&!best&&w.length>=5&&dl1(w,t))best=1;
    }
    return best;
  }
  /* Référence : entière (toujours), début, fin ou milieu (seulement si la saisie ressemble à une référence : un chiffre ou un point) */
  function skuPhrase(it,qs,qc,ref){
    var best=0;
    for(var k=0;k<it.skl.length;k++){
      var s=it.skl[k],c=it.skc[k],v=0;
      if(s===qs)v=100;else if(ref&&qs.length>=3){if(s.indexOf(qs)===0)v=80;else if(s.length>qs.length&&s.lastIndexOf(qs)===s.length-qs.length)v=70;else if(s.indexOf(qs)>-1)v=60;}
      if(!v&&qc.length>=3){if(c===qc)v=95;else if(ref){if(c.indexOf(qc)===0)v=75;else if(c.length>qc.length&&c.lastIndexOf(qc)===c.length-qc.length)v=65;else if(c.indexOf(qc)>-1)v=55;}}
      if(v>best)best=v;
    }
    return best;
  }
  var W={tt:[0,18,32,40],tyw:[0,12,30,40],tg:[0,8,16,22],cw:[0,0,9,12],dw:[0,3,6,9]};
  function wordScore(it,w){
    var best=0,h;
    h=hit(it.tt,w,false);if(h)best=Math.max(best,W.tt[h]);
    h=hit(it.tyw,w,false);if(h)best=Math.max(best,W.tyw[h]);
    h=hit(it.tg,w,false);if(h)best=Math.max(best,W.tg[h]);
    h=hit(it.cw,w,false);if(h)best=Math.max(best,W.cw[h]);
    h=hit(it.dw,w,false);if(h)best=Math.max(best,W.dw[h]);
    if(w.length>=3){var wc=w.replace(/[^a-z0-9]/g,'');for(var k=0;k<it.skl.length;k++){if(it.skl[k].indexOf(w)>-1||(wc.length>=3&&it.skc[k].indexOf(wc)>-1)){best=Math.max(best,/[\d.]/.test(w)?36:14);break;}}}
    if(!best){
      h=hit(it.tt,w,true);if(h)best=W.tt[h];
      if(!best){h=hit(it.tg,w,true);if(h)best=W.tg[h];}
      if(!best){h=hit(it.tyw,w,true);if(h)best=W.tyw[h];}
      if(!best){h=hit(it.dw,w,true);if(h)best=W.dw[h];}
    }
    return best;
  }
  function search(items,q){
    var qs=String(q||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[’'`´]/g,' ').replace(/\s+/g,' ').trim();
    if(qs.length<2)return {items:[],q:qs,kind:'none'};
    var qc=qs.replace(/[^a-z0-9]/g,''),ref=/[\d.]/.test(qs);
    var qn=norm(q);
    var words=qn.split(' ').filter(function(w){return w&&!STOP[w];});
    if(!words.length)words=qn.split(' ').filter(Boolean);
    var qg=/gilet|waistcoat|matelass|quilted/.test(qn);
    var out=[];
    for(var i=0;i<items.length;i++){
      var it=items[i],sc=0,ok=true,ws=0;
      var sp=skuPhrase(it,qs,qc,ref);
      for(var k=0;k<words.length;k++){var v=wordScore(it,words[k]);if(!v){ok=false;break;}ws+=v;}
      if(!ok&&!sp)continue;
      sc=sp*10+(ok?ws:0);
      if(words.length>1&&it.n.indexOf(qn)>-1)sc+=25;
      sc+=it.s===2?40:(it.s===1?15:0);
      sc+=it.a?30:0;
      sc+=it.tyb;
      if(it.gilet&&!qg)sc-=12;
      sc-=i*0.0005;
      out.push({it:it,sc:sc,sku:sp});
    }
    out.sort(function(a,b){return b.sc-a.sc;});
    return {items:out,q:qs,kind:out.length?(out[0].sku?'ref':'words'):'none'};
  }
  /* Chargement de l'index : pages de 250 articles, en parallèle, gardées 20 minutes dans le navigateur */
  var mem={};
  function fetchPage(root,page){
    return fetch(root+'collections/all?view=wk-index&sort_by=created-descending&page='+page,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('HTTP '+r.status);return r.text();}).then(function(t){var j=JSON.parse(t);if(!j||!j.i)throw new Error('index');return j;});
  }
  function load(root,locale){
    var key='wk-idx:'+VER+':'+locale;
    if(mem[key])return mem[key];
    var cached=null;
    try{var c=JSON.parse(localStorage.getItem(key)||'null');if(c&&c.t&&Date.now()-c.t<TTL&&c.rows&&c.rows.length)cached=c.rows;}catch(e){}
    if(cached){mem[key]=Promise.resolve(prepare(cached));return mem[key];}
    mem[key]=fetchPage(root,1).then(function(first){
      var n=first.pages||1,ps=[];
      for(var p=2;p<=n;p++)ps.push(fetchPage(root,p));
      return Promise.all(ps).then(function(rest){
        var rows=first.i.slice();rest.forEach(function(j){rows=rows.concat(j.i);});
        try{localStorage.setItem(key,JSON.stringify({t:Date.now(),rows:rows}));}catch(e){}
        return prepare(rows);
      });
    });
    mem[key].catch(function(){delete mem[key];});
    return mem[key];
  }
  root.WkSearchEngine={norm:norm,toks:toks,prepare:prepare,search:search,load:load,VER:VER,PER:PER};
})(typeof window!=='undefined'?window:globalThis);
